// Pass all the reducers that need to have a persistant state into the array
const whitelist: string[] = ['userReducer', 'authReducer']; // , 'postReducer'

export default whitelist;
